import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const PARTS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('PARTS');
export const PARTS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(PARTS_CRUD_ACTION_CONSTANTS);
